import Vue from 'vue'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_axios_58b48225 from 'nuxt_plugin_axios_58b48225' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_mintui_50a465e6 from 'nuxt_plugin_mintui_50a465e6' // Source: ../plugins/mintui (mode: 'all')
import nuxt_plugin_axios_fb9c9a02 from 'nuxt_plugin_axios_fb9c9a02' // Source: ../plugins/axios (mode: 'client')
import nuxt_plugin_bridge_753663c0 from 'nuxt_plugin_bridge_753663c0' // Source: ../plugins/bridge (mode: 'client')
import nuxt_plugin_wx_a8b5c610 from 'nuxt_plugin_wx_a8b5c610' // Source: ../plugins/wx (mode: 'client')
import nuxt_plugin_Mtah5_bcb272d2 from 'nuxt_plugin_Mtah5_bcb272d2' // Source: ../plugins/Mta-h5 (mode: 'client')
import nuxt_plugin_preview_68c7e7de from 'nuxt_plugin_preview_68c7e7de' // Source: ../plugins/preview (mode: 'client')
import nuxt_plugin_sentry_40a2c6d3 from 'nuxt_plugin_sentry_40a2c6d3' // Source: ../plugins/sentry (mode: 'client')
import nuxt_plugin_plugins_339fe556 from 'nuxt_plugin_plugins_339fe556' // Source: ../plugins (mode: 'all')
import nuxt_plugin_mta_6e03473a from 'nuxt_plugin_mta_6e03473a' // Source: ../plugins/mta (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp (ssrContext) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  const registerModule = store.registerModule
  store.registerModule = (path, rawModule, options) => registerModule.call(store, path, rawModule, Object.assign({ preserveState: process.client }, options))

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"doctor-app","meta":[{"http-equiv":"Content-Type","content":"text\u002Fhtml","charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1.0, user-scalable=0, viewport-fit=cover"},{"hid":"description","name":"description","content":"My shining Nuxt.js project"},{"http-equiv":"Content-Security-Policy","content":"upgrade-insecure-requests"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","href":"https:\u002F\u002Fimgm.kuaiwen.cn\u002Ffziy\u002Fdoct_male\u002Fvendor\u002Fmint-ui\u002Fmint-ui-v2.2.13.min.css"}],"script":[{"src":"https:\u002F\u002Fimgm.kuaiwen.cn\u002Ffziy\u002Fdoct_male\u002Fvendor\u002Fvue\u002Fvue.v2.6.11.min.js"},{"src":"https:\u002F\u002Fimgm.kuaiwen.cn\u002Ffziy\u002Fdoct_male\u002Fvendor\u002Fvue-router\u002Fvue-router.v3.2.0.min.js"},{"src":"https:\u002F\u002Fimgm.kuaiwen.cn\u002Ffziy\u002Fdoct_male\u002Fvendor\u002Fvuex\u002Fvuex.v3.5.1.min.js"},{"src":"https:\u002F\u002Fimgm.kuaiwen.cn\u002Ffziy\u002Fdoct_male\u002Fvendor\u002Fmint-ui\u002Fmint-ui-v2.2.13.min.js"},{"src":"https:\u002F\u002Fimgm.kuaiwen.cn\u002Ffziy\u002Fdoct_male\u002Fvendor\u002Fweixin-jssdk\u002Fjweixin-v1.3.2.min.js"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  const inject = function (key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Plugin execution

  if (typeof nuxt_plugin_axios_58b48225 === 'function') {
    await nuxt_plugin_axios_58b48225(app.context, inject)
  }

  if (typeof nuxt_plugin_mintui_50a465e6 === 'function') {
    await nuxt_plugin_mintui_50a465e6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axios_fb9c9a02 === 'function') {
    await nuxt_plugin_axios_fb9c9a02(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bridge_753663c0 === 'function') {
    await nuxt_plugin_bridge_753663c0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_wx_a8b5c610 === 'function') {
    await nuxt_plugin_wx_a8b5c610(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_Mtah5_bcb272d2 === 'function') {
    await nuxt_plugin_Mtah5_bcb272d2(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_preview_68c7e7de === 'function') {
    await nuxt_plugin_preview_68c7e7de(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentry_40a2c6d3 === 'function') {
    await nuxt_plugin_sentry_40a2c6d3(app.context, inject)
  }

  if (typeof nuxt_plugin_plugins_339fe556 === 'function') {
    await nuxt_plugin_plugins_339fe556(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_mta_6e03473a === 'function') {
    await nuxt_plugin_mta_6e03473a(app.context, inject)
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, () => {
        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from, next) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
